import {createContext} from "react";
import {CategoryNavContextType} from "./types";

export const CategoryNavContext = createContext<CategoryNavContextType>({
  activeLinkCSS: {},
  saleLinkCSS: {},
});
